export { default } from "./YesNoQuestionCard"
